import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=86db7d6c"
import script from "./NotFound.vue?vue&type=script&lang=js"
export * from "./NotFound.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('86db7d6c')) {
      api.createRecord('86db7d6c', component.options)
    } else {
      api.reload('86db7d6c', component.options)
    }
    module.hot.accept("./NotFound.vue?vue&type=template&id=86db7d6c", function () {
      api.rerender('86db7d6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/NotFound.vue"
export default component.exports